<template>
  <div class="modal-input-phone-wrapper-participans position-relative">
    <div class="modal-wrapper-part">
      <HeraSearchInput
        id="search-input"
        v-model="searchQuery"
        icon=""
        :debounce="700"
        class="search-input"
      />
      <div class="braking-lineing-modal"></div>
      <div class="participans-wrapper">
        <div
          v-if="isLoading"
          class="participant"
          style="align-items: center;min-height: 450px;justify-content: center;"
        >
          <Spinner />
        </div>
        <div v-if="!isLoading" class="participant">
          <div class="participant-info-row">
            <label class="user-field username-label">{{
              $t('web_participan_list-username', 'Username')
            }}</label>
            <label class="user-field">{{
              $t('web_participan_list-country', 'Country')
            }}</label>
          </div>
          <div
            v-for="user in filteredParticipants"
            :key="user.id"
            class="participant-info mb-4"
          >
            <LinkAccount
              :id="user.id"
              class="login link-account-hover"
              :type="playerType"
              blank
              @click="closeModal"
            >
              <Avatar
                :img-url="user.fields_data.avatar"
                :type="playerType"
                class="h-mr-3"
                :size="48"
              />
              <div class="participant-info-row">
                <span class="user-field">{{
                  playerType === 'profile' ? user.id : user.fields_data.username
                }}</span>
                <span class="user-field">{{ user.fields_data.Country }}</span>
              </div>
            </LinkAccount>
          </div>
          <div class="pagination-controls">
            <Btn :disabled="!prevPageToken" @click="prevPage"> &lt; </Btn>
            <span>Page {{ currentPage }}</span>
            <Btn :disabled="!nextPageToken" @click="nextPage">
              >
            </Btn>
          </div>
        </div>
      </div>
    </div>
    <Btn class="btn-primary" @click="closeModal">
      {{ $t('_web_close_modal', 'Close') }}
    </Btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LinkAccount from '@/components/links/Account';
import Avatar from '@/components/images/Avatar';
import HeraSearchInput from '@/components/molecules/form/HeraSearchInput';
import Btn from '@/components/atoms/HeraFormBtn.vue';
import Spinner from '@/views/main/components/Spinner.vue';

export default {
  components: {
    LinkAccount,
    Avatar,
    HeraSearchInput,
    Btn,
    Spinner,
  },
  props: {
    playerType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      participans: [],
      searchQuery: '',
      nextPageToken: null,
      prevPageToken: null,
      currentPage: 1,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['currentTournament']),
    filteredParticipants() {
      if (this.searchQuery.length === 0) {
        return this.participans;
      } else {
        const query = this.searchQuery.toLowerCase();
        if (this.playerType === 'profile') {
          return this.participans.filter(user =>
            user.id.toLowerCase().includes(query)
          );
        } else {
          return this.participans.filter(user =>
            user.fields_data.username.toLowerCase().includes(query)
          );
        }
      }
    },
  },
  watch: {
    $route() {
      this.closeOnRouteChange();
    },
  },
  async created() {
    await this.fetchParticipants();
  },
  methods: {
    ...mapActions(['getTournamentParticipants', 'closeModal']),
    async fetchParticipants(pageToken = null) {
      this.isLoading = true;
      try {
        const response = await this.getTournamentParticipants({
          id: this.currentTournament.id,
          query: { pageToken },
        });
        this.participans = response.items;
        this.nextPageToken = response.next_page_token;
        this.prevPageToken = response.prev_page_token;
      } catch (error) {
        console.error('Error fetching participants:', error);
      } finally {
        this.isLoading = false;
      }
    },
    nextPage() {
      this.currentPage += 1;
      this.fetchParticipants(this.nextPageToken);
    },
    prevPage() {
      this.currentPage -= 1;
      this.fetchParticipants(this.prevPageToken);
    },
    closeOnRouteChange() {
      if (!this.$route.path.includes('tournament')) {
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-input-phone-wrapper-participans {
  flex-direction: column;
  max-width: 550px;
  min-width: 400px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 580px !important;
  height: 100%;
  .participans-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: auto;
    max-height: 455px;
  }
  .link-account-hover:hover {
    color: unset !important;
  }
  .link-account-hover {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
  .participant {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 10px;
  }
  .participant-info {
    display: flex;
    width: 100%;
  }
  .participant-info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    justify-content: space-between;
  }
  label {
    font-weight: bold;
  }
  .username-label {
    @include auto-rtl(margin-right, 38px);
    @include auto-rtl(margin-left, 20px);
  }
  .braking-lineing-modal {
    height: 1px;
    margin-top: 19px;
    margin-bottom: 19px;

    background: #30374a;
    width: 100%;
  }
  .user-field {
    min-width: 100px;
    max-width: 100px;
    overflow: hidden;
  }
  .modal-wrapper-part {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
.pagination-controls {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.pagination-button {
  padding: 5px 10px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
}
.pagination-button:disabled {
  background-color: #c0c0c0;
  cursor: not-allowed;
}
</style>
